import { render, staticRenderFns } from "./baseMobHeadTwo.vue?vue&type=template&id=118eaa96&scoped=true"
import script from "./baseMobHeadTwo.vue?vue&type=script&lang=js"
export * from "./baseMobHeadTwo.vue?vue&type=script&lang=js"
import style0 from "./baseMobHeadTwo.vue?vue&type=style&index=0&id=118eaa96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "118eaa96",
  null
  
)

export default component.exports